import { useNavigate, type NavigateFunction, type To, type NavigateOptions } from 'react-router-dom';
import { cleanUpReactElements } from '@vse-legacy/machinelogic_react_components_support';

/**
 * a hook that returns a function that unmounts all react elements and then navigates to the given path
 * @return {import("react-router-dom").NavigateFunction} A navigation callback.
 */
export const useUnmountReactAndNavigate = (): (to: To, options?: NavigateOptions | undefined) => void => {
  const navigate = useNavigate();

  return createUnmountReactAndNavigate(navigate);
};

/**
 * a function that returns a function that unmounts all react elements and then navigates to the given path
 * @param {import("react-router-dom").NavigateFunction} navigate  A navigation callback.
 * @return {import("react-router-dom").NavigateFunction} A navigation callback.
 */
export const createUnmountReactAndNavigate = (navigate: NavigateFunction): (to: To, options?: NavigateOptions | undefined) => void => {
  return (to, options) => {
    cleanUpReactElements();
    navigate(to, options);
  };
};
